import { createPortal } from "react-dom";
import { Card, Option } from "../../api/tooling";
import { ApprovalBadge } from "./ToolingShared";

const printText = (value: string, limit: number) => {
  const text = value.replace(/\s+/g, " ").trim();
  return text.length > limit ? `${text.slice(0, limit - 1).trimEnd()}…` : text;
};
const printDate = (value: string | null) =>
  value
    ? new Date(value).toLocaleDateString("en-IN", {
        timeZone: "Asia/Kolkata",
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
    : "—";

export default function CardPrint({
  card,
  issues,
  statuses,
}: {
  card: Card;
  issues: Option[];
  statuses: Option[];
}) {
  return createPortal(
    <article className="tool-card-print">
      <header className="tool-print-header">
        <div>
          <span className="tool-print-brand">PRESSCO · TOOL DEVELOPMENT</span>
          <h1>{card.tool.code}</h1>
        </div>
        <div className="tool-print-reference">
          Card #{card.id}
          <br />
          Rev. {card.version}
        </div>
      </header>
      <div className="tool-print-approval">
        <ApprovalBadge card={card} />
      </div>
      <dl className="tool-print-meta">
        <div>
          <dt>Issue</dt>
          <dd>
            {printText(
              issues.find((i) => i.value === card.issue_type)?.label ||
                card.issue_type,
              75
            )}
          </dd>
        </div>
        <div>
          <dt>Stage</dt>
          <dd>
            {statuses.find((s) => s.value === card.status)?.label ||
              card.status}
          </dd>
        </div>
        <div>
          <dt>Type / operation</dt>
          <dd className="text-capitalize">
            {card.tool.type} / {card.tool.operation}
          </dd>
        </div>
        <div>
          <dt>Die makers</dt>
          <dd>{printText(card.makers.map((m) => m.name).join(", "), 100)}</dd>
        </div>
      </dl>
      <div className="tool-print-links">
        <section>
          <h2>Linked parts</h2>
          <p>
            {printText(
              card.tool.parts
                .map((part) => `${part.part_name} (#${part.part_id})`)
                .join("; "),
              200
            )}
          </p>
        </section>
        <section>
          <h2>Drawing names</h2>
          <p>
            {printText(
              card.tool.parts
                .map((part) => part.drawing_name || "No drawing name")
                .join("; "),
              200
            )}
          </p>
        </section>
      </div>
      <section className="tool-print-details">
        <h2>Card details</h2>
        <p>{printText(card.detail, 360)}</p>
      </section>
      <footer className="tool-print-dates">
        <span>
          Created <strong>{printDate(card.created_at)}</strong>
        </span>
        <span>
          Completed <strong>{printDate(card.completed_at)}</strong>
        </span>
        <span>
          Approved <strong>{printDate(card.approved_at)}</strong>
        </span>
      </footer>
    </article>,
    document.body
  );
}
